/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import ky from 'ky'
import { responseToCamelCase } from '@alice-health/ky-hooks-change-case'
import { transform, isArray, isObject, snakeCase } from 'lodash-es'
import { getToken } from '@/services/auth'

const mapKeysDeepToSnakeCase = obj =>
  transform(obj, (result, value, key) => {
    let data = value
    if (isArray(value)) data = value.map(item => mapKeysDeepToSnakeCase(item))
    if (isObject(value)) data = mapKeysDeepToSnakeCase(value)
    result[snakeCase(key).replace(/_(\d)/g, '$1')] = data
  })

let promiseResolver

const criticalError = new Promise(resolve => {
  promiseResolver = resolve
})

const transformRequestToSnakeCase = async (input, options) => {
  if (options.body && !(options.body instanceof FormData)) {
    const body = JSON.parse(options.body)
    const convertedBody = mapKeysDeepToSnakeCase(body)
    return new Request(input, { body: JSON.stringify(convertedBody) })
  }
}

const checkError = async (input, options, response) => {
  if (!response.ok) {
    promiseResolver(response)
  } else if (['POST,', 'PUT'].includes(input.method)) {
    const responseBody = await response.json()
    if (responseBody.error) {
      const { detailMessage } = responseBody.error
      throw Error(detailMessage)
    }
  }
}

const getRange = (dataOptions, contentRange) => {
  const { page, itemsPerPage } = dataOptions
  const isFirstPage = page === 1
  const start = isFirstPage ? 0 : itemsPerPage * (page - 1)
  const end = (isFirstPage ? itemsPerPage : itemsPerPage * page) - 1
  return [start, contentRange > 0 ? Math.min(end, contentRange) : end]
}

const setTokenOnRequestHeader = async input => {
  const idToken = await getToken()
  input.headers.set('Authorization', `Bearer ${idToken}`)
}

const instance = ky.create({
  prefixUrl: import.meta.env.VITE_API_PREFIX_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  hooks: {
    beforeRequest: [transformRequestToSnakeCase],
    afterResponse: [responseToCamelCase]
  }
})

const instanceAuth = ky.create({
  prefixUrl: import.meta.env.VITE_API_PREFIX_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  hooks: {
    beforeRequest: [transformRequestToSnakeCase],
    afterResponse: [responseToCamelCase]
  }
})

const instanceWithToken = ky.create({
  prefixUrl: import.meta.env.VITE_API_PREFIX_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  },
  hooks: {
    beforeRequest: [setTokenOnRequestHeader, transformRequestToSnakeCase],
    afterResponse: [responseToCamelCase, checkError]
  }
})

export { criticalError, getRange, instance, instanceWithToken, instanceAuth }
